<template>
  <div class="outer-wrapper">
    <van-nav-bar
        title="包裹入库"
        left-text="返回"
        left-arrow
        @click-left="goBack"
        fixed
      >
      </van-nav-bar>
        <div style="padding-top: 0.4rem">
          <van-cell title="快递单号" title-class="cell-t" value-class="value-t" :value="receivedPackage.delivery_no"  />
          <van-cell title="收件人" title-class="cell-t" value-class="value-t" :value="receivedPackage.addressee"  />
          <van-cell title="收件时间" title-class="cell-t" value-class="value-t" :value="receivedPackage.op_time"  />
          <van-cell title="收取人" title-class="cell-t" value-class="value-t" :value="receivedPackage.operator_name"  />
          <van-cell title="备注" title-class="cell-t" :label="receivedPackage.remark" />
          <van-cell title="入库状态" title-class="cell-t" value-class="value-t" :value="receivedPackage.warehouseList.length>0?'已入库':'未入库'"  />
            <div v-if="receivedPackage.warehouseList.length>0">
              <van-cell title="入库时间" title-class="cell-t" value-class="value-t" :value="receivedPackage.warehouseList[0].in_time" />
              <van-cell title="当前所占库位：" :value="'共'+receivedPackage.warehouseList.length+'个'"/>
              <van-cell :title="index+1" title-class="cell-t" value-class="value-t" :value="ele.display_no" v-for="(ele,index) in receivedPackage.warehouseList" :key="index"/>
            </div>
            <van-cell title="当前包裹照片" title-class="cell-t" is-link value="大图预览" @click="preview(receivedPackage.imgList)"/>
          <img-slide
            :imgList="receivedPackage.imgList.map((val) => val.static_url)"
            height="3rem"
            @tapOne="index=>{confirm(index)}"
          >
          </img-slide>
          <p class="line-t"></p>
          <van-panel title="新增图片：" desc status>
            <div class="d-wrapper">
              <van-uploader
                :after-read="handleAfterRead"
                deletable
                v-model="imgList"
                capture="camera"
              />
            </div>
          </van-panel>
          <!-- <van-field
            v-model="locationNo"
            label="库位编号"
            maxlength="30"
            placeholder="请输入要转移到的库位编号"
          />
          <div class="button-wrapper">
            <van-button
              color="#ee0a24"
              style="width: 4rem"
              @click="checkSubmit"
              :disabled="!submitAbled"
              >提交</van-button
            >
            <van-button
              color="#ee0a24"
              plain
              style="width: 4rem; margin-left: 1rem"
              @click="reSet"
              >重置</van-button
            >
          </div> -->
        </div>
        <div class="submit-b-wrapper">
        <van-button type="warning" class="suspend-b" block @click="wareOut">出库</van-button>
        <van-button type="info" class="submit-b" block @click="wareIn">入库</van-button>
      </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import imgSlide from "@/components/Common/ImgSlide.vue";
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));


function packageFac(){
  return {
    delivery_no:'',
    addressee:'',
    imgList:[],
    warehouseList:[],
    remark:''
  };
}

export default {
  name: "packageOp",
  components: {
    imgSlide,
  },
  props: {
    enid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading:false,
      receivedPackage: packageFac(),
      imgList: [],
      locationNo:'',
    };
  },
  watch: {},
  computed: {
    submitAbled: function () {
      if (this.imgList.length>0&&this.locationNo) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData(){
      this.loading = true;
      this.$axios
        .post(this.$url + "/update_package", {
          userToken: userToken,
          ask_data: "packageInfo",
          enid: this.enid,
        })
        .then((response) => {
          if(response.data.stat==='ok'){
            this.receivedPackage = response.data.res_record;
            if(this.receivedPackage.warehouse_display_no){
              this.locationNo = this.receivedPackage.warehouse_display_no;
            }
            for (let item of this.receivedPackage.imgList) {
              item.static_url = this.$fileUrlFac(
                item.img_url,
                authData.sfileRight
              );
            }
          }
          this.loading = false;
        });
    },
    wareOut() {
      this.$axios
        .post(this.$url + "/lab_manage", {
          userToken: userToken,
          ask_data: "wareOut",
          target:'package',
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("出库成功！");
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    wareIn(){
      this.$axios
        .post(this.$url + "/lab_manage", {
          userToken: userToken,
          ask_data: "wareIn",
          target:'package',
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast("请在1分钟内扫描要放入的库位二维码！");
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    checkSubmit() {
      if (this.submitAbled) {
        let form = new FormData();
        form.append("userToken", userToken);
        form.append("enid", this.enid);
        form.append("locationNo", this.locationNo);
        form.append("askData", "updatePackage");
        for (let img of this.imgList) {
          if (img.obj !== undefined) {
            form.append("packageImg", img.obj);
          }
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(this.$url + "/update_package", form, config)
          .then((response) => {
            if (response.data.stat === "ok") {
              this.$toast.success("包裹信息上传成功！");
              setTimeout(()=>{
                this.goBack();
              },1000);
            } else {
              this.$toast.fail(response.data.error_info);
            }
          })
          .catch((error) => {
            this.$toast.fail(error + "网络连接失败！");
          });
      }
    },
    handleAfterRead(img, detail) {
      if (img.file.size < 1024 * 200) {
        this.imgList[detail.index].obj = img.file;
      } else {
        let vm = this;
        var reader = new FileReader();
        reader.readAsDataURL(img.file);
        reader.onload = function (e) {
          let img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            let width = 800, //图像大小
              quality = 0.7, //图像质量
              canvas = document.createElement("canvas"),
              drawer = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = width * (img.height / img.width);
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            vm.imgList[detail.index].url = canvas.toDataURL(
              "image/jpeg",
              quality
            );
            vm.imgList[detail.index].obj = vm.convertBase64UrlToFile(
              vm.imgList[detail.index].url,
              "img" + detail.index + ".jpeg"
            );
            this.imgAlter = true;
          };
        };
      }
    },
    convertBase64UrlToFile(urlData, filename) {
      let arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    preview(item) {
      ImagePreview({ images: item.map((val) => val.static_url) });
    },
    goBack(){
      location.href = '/packageManage';
    },
    reSet(){
      this.locationNo = '';
      this.imgList = [];
    },
    confirm(index) {
      this.$dialog
        .confirm({
          title: '',
          message: "确认删除本图片？",
          beforeClose: (action, done) => {
            if (action === "confirm") {
              this.loading = "spin";
              this.$axios
                .post(this.$url + "/update_package", {
                  userToken: userToken,
                  ask_data: "imgDel",
                  img_id: this.receivedPackage.imgList[index].id,
                })
                .then((response) => {
                  if (response.data.stat === "ok") {
                    done();
                    this.$toast.success("操作成功！");
                    window.location.reload();
                  } else {
                    done();
                    this.$toast.fail("失败！");
                  }
                });
            } else if (action === "cancel") {
              done();
            } else {
              done();
            }
          },
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-right: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.date-filter {
  text-align: center;
  position: relative;
  font-size: 0.6rem;
  color: #666;
  padding: 0.8rem 0.2rem;
}

.last-day-span {
  position: absolute;
  left: 1rem;
  color: blue;
}

.next-day-span {
  position: absolute;
  right: 1rem;
  color: blue;
}

.icon-s {
  position: relative;
  top: 0.2rem;
}

.remark-p {
  border-top: 1px solid #eee;
  border-bottom: 3px double #ddd;
  padding: 0 0.3rem;
  text-align: right;
}

.des-p{
  padding: 0.5rem 0.8rem;
  font-size: 0.8rem;
  color: #333;
  border-top: 1px solid #eee;

}

.des-label{
  font-size:0.6rem;
  color:#999;
}

.cell-t{
  color:#999;
}

.value-t{
  color:#333;
}

.line-t{
  margin:0.4rem 0;
  border:1px solid #333;
}
.suspend-b {
  width: 6rem;
}

.record-value {
  text-indent: 1rem;
}

.submit-b-wrapper{
    position: fixed;
    bottom:0;
    display:flex;
    width:100%;
}
</style>